import { useState, useEffect } from 'react';
import { createModel } from 'hox';
import { ISCMSaleRoDescType, ISCMSaleRoFormFields, ISCMSaleRoGoodsDetail } from './scmSaleRoType';
import useGlobalModel from '@/model/globalModel';
import { ISCMDictDetail, ISCMDictSearch, saleRoService } from './scmSaleRoService';
import useStorageState from '@/hooks/useStorageState';
import { forFind } from '@/utils/utils';

type dictObj = {
	[key: string]: any;
};

const initRoDesc = {
	actualAmount: 0, //实际总价合计 （数量*单价）
	//对应展示字段
	numAll: 0, //开单
	kindAll: 0, //种类
	confirmAll: 0, //确认
	rejectAll: 0, //驳回
	amountAll: 0, //总计   （去除下浮，赠品的金额）
	stockAmountAll: 0, //入库总计   （去除下浮）
	giftAmountAll: 0, //赠品总计
};

function listChangeTree(list: ISCMDictDetail[]) {
	let menuObj: dictObj = {};
	list.forEach((item) => {
		item.children = [];
		menuObj[item.code] = item;
	});
	return list.filter((item) => {
		if (item.pcode !== null && item.pcode !== '') {
			menuObj[item.pcode]?.children.push(item);
			return false;
		}
		return true;
	});
}

export const useScmSaleRoDetailModel = createModel(function () {
	const {
		user: { shopId, shopName, userName },
	} = useGlobalModel();

	const initRoFormVal = {
		shopName,
		createUser: userName,
		operator: userName,
		returnCode: '', //销售退货单编码
		status: '', //销售退货单状态
		favorableAmount: '0', //整单优惠
		discountTotalAmount: '0.00', //优惠总额
		paidAmount: '0.00', //已付金额
		totalAmount: '0.00', //应付金额
		discountRate: '0', //整单下浮
		stockIoTotalAmount: '0.00', //入库金额
	} as ISCMSaleRoFormFields;

	// 供应链查看
	const [lookRoFormVal, setLookRoFormVal] = useState<ISCMSaleRoFormFields>(initRoFormVal);
	const [lookRoGoodsList, setLookRoGoodsList] = useState<ISCMSaleRoGoodsDetail[]>([]);
	const [lookRoDesc, setLookRoDesc] = useState<ISCMSaleRoDescType>(initRoDesc);
	// 供应链字典源
	const [scmTreeSource, setScmTreeSource, clearScmTreeSource] = useStorageState<ISCMDictDetail[]>(
		'scmDictTree',
		[]
	); //字典数据源
	const [ngaTreeSource, setNgaTreeSource, clearNgaTreeSource] = useStorageState<ISCMDictDetail[]>(
		'ngaDictTree',
		[]
	); //字典数据源
	useEffect(() => {
		let newDesc: ISCMSaleRoDescType = { ...initRoDesc };
		lookRoGoodsList.forEach((item) => {
			newDesc.numAll += Number(item.num);
			newDesc.confirmAll += Number(item.confirmNum);
			newDesc.rejectAll += Number(item.rejectNum);
			newDesc.amountAll += Number(item.amount);
			newDesc.actualAmount += Number(item.num) * Number(item.price);
			newDesc.stockAmountAll += Number(item?.stockIoAmount ?? 0);
			newDesc.giftAmountAll += Number(item.giftsNum) * Number(item.price);
		});
		newDesc.kindAll = new Set(lookRoGoodsList.map((item) => item.materialCode)).size ?? 0;
		setLookRoDesc(newDesc);
		// console.log(editGoodsList,newDesc)
	}, [lookRoGoodsList]);

	// 供应链字典列表请求
	const loadScmDictData = async () => {
		let data: ISCMDictSearch = {
			sourceApp: 'scm',
			page: {
				pageSize: -1,
				pageNum: 1,
			},
		};
		// let { retData } = await saleRoService.page(data);
		// let { records } = retData;
		// // setOriginDictList(records);
		// setScmTreeSource(listChangeTree(records.filter((item) => item.enable)));
		setScmTreeSource(listChangeTree([]))
	};
	// 供应链字典列表请求
	const loadNgaDictData = async () => {
		let data: ISCMDictSearch = {
			sourceApp: 'main',
			page: {
				pageSize: -1,
				pageNum: 1,
			},
		};
		// let { retData } = await saleRoService.ngaPage(data);
		// let { records } = retData;
		// // setOriginDictList(records);
		// setNgaTreeSource(listChangeTree(records.filter((item) => item.enable)));
		setNgaTreeSource(listChangeTree([]))
	};
	//获取一条数据
	const getSaleRoDetailOne = async (id: string) => {
		let { retData } = await saleRoService.roOne(id);

		if (retData) {
			let { details, ...formVal } = retData;
			setLookRoGoodsList(() => details.map((item) => ({ ...item, key: item.id })));
			setLookRoFormVal({
				...formVal,
				brandName: getTreeNodeName(formVal.brandCode),
				invoiceTypeName: getTreeNodeName(formVal.invoiceTypeCode),
			});
			// setIsCancel(retData.status === DictCodeEnmu.SALE_RETURN_STATUS_CANCEL ? true : false);  //判断是否已作废
			// setEditIsDirect(retData.purchaseTypeCode === DictCodeEnmu.PURCHASE_TYPE_DIRECT ? true : false);  //判断直发类型
		}
	};

	//根据code 返回对应的node节点名称
	const getTreeNodeName = (code: string): string => {
		let obj: dictObj = {};
		let findTree: ISCMDictDetail | undefined = forFind(scmTreeSource, code, 'code');
		return findTree ? findTree['name'] : '';
	};

	const resetLookCatch = () => {
		setLookRoFormVal(initRoFormVal);
		setLookRoGoodsList([]);
	};

	return {
		lookRoFormVal,
		lookRoDesc,
		lookRoGoodsList,
		scmTreeSource,
		ngaTreeSource,
		getTreeNodeName,
		setLookRoGoodsList,
		getSaleRoDetailOne,
		loadScmDictData,
		resetLookCatch,
		loadNgaDictData
	};
});
